import { ApplicationInsights, DistributedTracingModes, type ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const BROWSER_ROLE_NAME = import.meta.env.DEV ? 'airchef-frontend-local' : 'airchef-frontend';

const hostOf = (url: string | undefined) => {
  if (!url) return undefined;

  try {
    return new URL(url).host;
  } catch {
    return undefined;
  }
};

// Correlation headers are only attached to cross-origin calls when the target host is allowlisted.
const backendHosts = [
  hostOf(import.meta.env.VITE_AIRCHEF_API_URL),
  hostOf(import.meta.env.VITE_PIM_API_URL),
  hostOf(import.meta.env.VITE_AIRCHEF_WS_URL),
].filter((host): host is string => !!host);

const browserHistory = createBrowserHistory();
export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING ?? '',
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
    distributedTracingMode: DistributedTracingModes.W3C,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    correlationHeaderDomains: backendHosts,
  },
});

appInsights.loadAppInsights();

// Without an explicit role name the browser telemetry is mapped by page domain instead of the app.
appInsights.addTelemetryInitializer((item: ITelemetryItem) => {
  item.tags = item.tags ?? [];
  item.tags['ai.cloud.role'] = BROWSER_ROLE_NAME;
});
